import { conteoPorClave } from '../../lib/sesion';
import { Barras } from '../primitivas/Barras';
import type { PropsVista } from './registro';

/**
 * Vista `barras`: ranking por opción elegida (o por valor de escala si la
 * primitiva es de posición). Tally SIN autores (C7). Respeta `opciones` del
 * manifiesto: `titulo` y `top` (recorte del ranking).
 */
export function VistaBarras({ aportes, total, opciones }: PropsVista) {
  // La clave del tally la puede declarar el manifiesto (`opciones.campo`, p. ej.
  // "aspecto" en la retro). Sin declarar: voto → opcion, posición → valor,
  // detectado por presencia, sin ramificar por herramienta.
  let conteo: Map<string, number>;
  if (typeof opciones.campo === 'string') {
    conteo = conteoPorClave(aportes, opciones.campo);
  } else {
    const porOpcion = conteoPorClave(aportes, 'opcion');
    conteo = porOpcion.size > 0 ? porOpcion : conteoPorClave(aportes, 'valor');
  }
  if (conteo.size === 0) return null;

  const titulo = typeof opciones.titulo === 'string' ? opciones.titulo : 'Cómo votó la sala';
  const top = typeof opciones.top === 'number' ? opciones.top : null;

  let filas = [...conteo.entries()].map(([k, n]) => ({ etiqueta: k, n }));
  filas.sort((a, b) => b.n - a.n);
  if (top != null && filas.length > top) filas = filas.slice(0, top);

  return <Barras titulo={titulo} filas={filas} total={total} />;
}
